import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchSpecialVisitSessions = async ({ trialId, patientId, visitNumber }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();

  if (!!patientId) params.append("patient_id", patientId);
  if (!!visitNumber) params.append("visit_number", visitNumber);

  const URL = `${__API_URL__}/api/photos/special_visit_sessions/${trialId}/?${params.toString()}`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useSpecialVisitSessions = ({ trialId, patientId, visitNumber, enabled = true }) => {
  return useQuery({
    queryKey: ["special_visit_sessions", trialId, patientId, visitNumber],
    queryFn: () => fetchSpecialVisitSessions({ trialId, patientId, visitNumber }),
    enabled: enabled && !!trialId && !!patientId && visitNumber !== undefined,
  });
};

export default useSpecialVisitSessions;
